import { all, takeEvery, debounce } from 'redux-saga/effects'

import { setFileDeletionSaga } from 'store/file/sagas/set-file-deletion'
import { updateFileDataSaga } from './sagas/update-file-data'

import * as actions from './file.actions'

export default function* () {
  yield all([
    takeEvery(actions.UPDATE_FILE_DATA_REQUEST, updateFileDataSaga),
    debounce(1000, actions.ROTATE_FILE_REQUEST, updateFileDataSaga),
    takeEvery(actions.SET_FILE_DELETION_REQUEST, setFileDeletionSaga),
  ])
}
